import { Button, Input, Row, Space, Tabs, Select } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout";
import { useMatStyles } from "./style";
import styled from "styled-components";
import {
  Box,
  TableCell,
  TableRow,
  Grid as MatGrid,
  Paper,
} from "@mui/material";
import { getComparator, stableSort } from "../../utils/helper";
import { customBaseUrl, httpGet, httpPost, httpPut } from "../../store/http";
import { hideLoader, showLoader } from "../../utils/loader";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import AntDropdown from "../../components/CustomDropdown/AntDropdown";
import ViewDocModal from "../../components/Modal/ViewDoc";
import Swal from "sweetalert2";
import moment from "moment";
import CreateBranch from "./modals/createBranch";
import CardType from "./cardType";
import CardProducts from "./products";
import { CSVLink } from "react-csv";
import DeliveryFees from "./DeliveryFees";
import SingleCardRequest from "./modals/SingleCardRequest";

const { TabPane } = Tabs;
const { Option } = Select;

const Container = styled.div``;

const CardsMainPage = () => {
  const navigate = useNavigate();
  const [orderData, setOrderData] = useState({
    order: "asc",
    orderBy: "businessName",
  });
  const [metaData, setMetaData] = useState(0);
  const [pagination, setPagination] = useState({ current: 0, pageSize: 10 });
  const [usersData, setUsersData] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [showCreateBranch, setShowCreateBranch] = useState(false);
  const [showSingleCardRequestModal, setShowSingleCardRequestModal] = useState(false);
  const [showViewDocModal, setShowViewDocModal] = useState(false);
  const [viewData, setViewData] = useState({});
  const [field, setField] = useState(null);
  const [value, setValue] = useState(null);
  const [statusFilter, setStatusFilter] = useState('PENDING');
  const styles = useMatStyles();

  const handleDropdownAction = (item, row) => {
    const cardId = row?.cardId || row?.id;
    if (item === "APPROVE") approveReject(row?.id, "APPROVED");
    if (item === "REJECT") approveReject(row?.id, "REJECTED");
    if (item === "BLOCK") handleBlock(cardId);
    if (item === "UNBLOCK") handleUnblock(cardId);
    if (item === "ACTIVATE") handleActivate(cardId);
    if (item === "RESET PIN") handleResetPin(cardId);
    if (item === "DEACTIVATE") handleDeactivate(cardId);
    if (item === "CANCEL") handleCancel(cardId);
    if (item === "EXPORT") handleExport(cardId);
  };

  const handleSettingsDropdown = (item) => {
    if (item === "Bulk Request") setShowCreateBranch(true); // Reusing CreateBranch modal for bulk request for now
    if (item === "Single Request") setShowSingleCardRequestModal(true);
  };

  const approveReject = async (id, status) => {
    const { value: reason } = await Swal.fire({
      title: `Enter reason for ${status}`,
      input: 'text',
      inputLabel: 'Reason',
      inputValue: status === 'APPROVED' ? 'approved' : '',
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return 'You need to provide a reason!'
        }
      }
    })

    if (reason) {
      showLoader();
      const res = await httpPost(
        `${customBaseUrl.cardUrl}/cms/card-request/card/approveOrReject/${id}?reason=${reason}&status=${status}`,
        {}, true, null, true
      );
      if (res.status === true) {
        hideLoader();
        await Swal.fire('Done', res?.message, 'success')
        getCards();
      } else {
        hideLoader();
        Swal.fire('error', res?.message)
      }
    }
  }
  const handleBlock = async (id) => {
    const { value: reason } = await Swal.fire({
      title: 'Enter reason for Blocking Card',
      input: 'text',
      inputLabel: 'Reason',
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return 'You need to provide a reason!'
        }
      }
    })

    if (reason) {
      showLoader();
      const res = await httpPut(
        `${customBaseUrl.cardUrl}/cms/admin/admin-block-Card/${id}?reason=${reason}`,
        {}, null, true, true
      );
      if (res.status === true) {
        hideLoader();
        await Swal.fire('Done', res?.message, 'success')
        getCards();
      } else {
        hideLoader();
        Swal.fire('error', res?.message)
      }
    }
  }
  const handleUnblock = async (id) => {
    const res = await httpPut(
      `${customBaseUrl.cardUrl}/admin/admin-unblock-card/${id}`,
      {}, null, true, true
    );
    if (res.status === true) {
      hideLoader();
      Swal.fire('Done', res?.message, 'success')
      getCards();
    } else {
      hideLoader();
      Swal.fire('error', res?.message)
    }
  }
  const handleActivate = async (id) => {
    const { value: pinValues } = await Swal.fire({
      title: 'Activate Card',
      html:
        '<div style="margin-bottom: 10px; text-align: left;"><label style="font-weight: 500;">Default PIN</label>' +
        '<input id="swal-default-pin" type="password" class="swal2-input" placeholder="Default PIN" value="1111" maxlength="4" style="margin-top: 5px; width: 80%;"></div>' +
        '<div style="text-align: left;"><label style="font-weight: 500;">New PIN</label>' +
        '<input id="swal-new-pin" type="password" class="swal2-input" placeholder="New PIN (4 digits)" maxlength="4" style="margin-top: 5px; width: 80%;"></div>',
      focusConfirm: false,
      showCancelButton: true,
      preConfirm: () => {
        const defaultPin = document.getElementById('swal-default-pin').value;
        const newPin = document.getElementById('swal-new-pin').value;
        if (!defaultPin) {
          Swal.showValidationMessage('Default PIN is required');
          return false;
        }
        if (!newPin || newPin.length !== 4 || !/^\d+$/.test(newPin)) {
          Swal.showValidationMessage('New PIN must be exactly 4 digits');
          return false;
        }
        return { defaultPin, newPin };
      }
    });

    if (pinValues) {
      showLoader();
      const res = await httpPost(
        `${customBaseUrl.cardUrl}/cms/admin/approvals/submit/activate`,
        {
          cardId: parseInt(id, 10),
          defaultPin: pinValues.defaultPin,
          newPin: pinValues.newPin
        },
        null, null, true
      );
      if (res?.success === true || res?.status === true || res?.message?.toLowerCase()?.includes('success')) {
        hideLoader();
        await Swal.fire('Done', res?.message || 'Card activation request submitted successfully', 'success');
        getCards();
      } else {
        hideLoader();
        Swal.fire('error', res?.message || 'Failed to submit card activation');
      }
    }
  };

  const handleResetPin = async (id) => {
    const { value: newPin } = await Swal.fire({
      title: 'Reset Card PIN',
      input: 'password',
      inputLabel: 'Enter New PIN',
      inputPlaceholder: 'New PIN (4 digits)',
      showCancelButton: true,
      inputAttributes: {
        maxlength: 4,
        autocapitalize: 'off',
        autocorrect: 'off'
      },
      inputValidator: (value) => {
        if (!value || value.length !== 4 || !/^\d+$/.test(value)) {
          return 'New PIN must be exactly 4 digits';
        }
      }
    });

    if (newPin) {
      showLoader();
      const res = await httpPost(
        `${customBaseUrl.cardUrl}/cms/admin/approvals/submit/reset-pin`,
        {
          cardId: parseInt(id, 10),
          newPin: newPin
        },
        null, null, true
      );
      if (res?.success === true || res?.status === true || res?.message?.toLowerCase()?.includes('success')) {
        hideLoader();
        await Swal.fire('Done', res?.message || 'Card PIN reset request submitted successfully', 'success');
        getCards();
      } else {
        hideLoader();
        Swal.fire('error', res?.message || 'Failed to submit card PIN reset');
      }
    }
  };
  const handleDeactivate = async (id) => {
    const res = await httpPut(
      `${customBaseUrl.cardUrl}/cms/admin/card/deactivate/${id}`,
      {}, null, true, true
    );
    if (res.status === true) {
      hideLoader();
      Swal.fire('Done', res?.message, 'success')
      getCards();
    } else {
      hideLoader();
      Swal.fire('error', res?.message)
    }
  }
  const handleCancel = async (id) => {
    const res = await httpPut(
      `${customBaseUrl.cardUrl}//cms/card-request/cancel-single-card?requestId=${id}`,
      [id],
    );
    if (res.status === true) {
      hideLoader();
      Swal.fire('Done', res?.message, 'success')
      getCards();
    } else {
      hideLoader();
      Swal.fire('error', res?.message)
    }
  }

  const handleExport = async (id) => {
    const adminEmail = localStorage.getItem('email') || '';
    const { value: formValues } = await Swal.fire({
      title: 'Export Card',
      html:
        `<input id="swal-input1" class="swal2-input" placeholder="Admin Email to Notify" value="${adminEmail}">` +
        '<input id="swal-input2" type="number" class="swal2-input" placeholder="Limit" value="0">',
      focusConfirm: false,
      showCancelButton: true,
      preConfirm: () => {
        const adminToNotify = document.getElementById('swal-input1').value;
        const limit = document.getElementById('swal-input2').value;
        if (!adminToNotify) {
          Swal.showValidationMessage('Admin email is required');
          return false;
        }
        return {
          adminToNotify,
          limit: parseInt(limit, 10) || 0
        }
      }
    })

    if (formValues) {
      showLoader();
      const res = await httpPost(
        `${customBaseUrl.cardUrl}/cms/cards/export-single?cardId=${id}`,
        formValues, true, null, true
      );
      if (res && (res.status === true || res.message?.toLowerCase()?.includes('success'))) {
        hideLoader();
        Swal.fire('Done', res?.message || 'Export initiated successfully', 'success');
      } else {
        hideLoader();
        Swal.fire('Error', res?.message || 'Export failed', 'error');
      }
    }
  }
  const columns = [
    { field: 'customerName', headerName: 'Name', width: 250, headerClassName: styles.tableHeader },
    { field: 'customerEmail', headerName: 'Email', width: 250, headerClassName: styles.tableHeader },
    { field: 'mobile', headerName: "Phone", width: 250, headerClassName: styles.tableHeader },
    { field: 'state', headerName: "State", width: 250, headerClassName: styles.tableHeader },
    { field: 'lga', headerName: "LGA", width: 250, headerClassName: styles.tableHeader },
    { field: 'address', headerName: "Address", width: 250, headerClassName: styles.tableHeader },
    { field: 'cardType', headerName: "Card Type", width: 200, headerClassName: styles.tableHeader, renderCell: ({ row }) => row?.cardType ?? 'NA' },
    { field: 'accountNumber', headerName: "Account Number", width: 150, headerClassName: styles.tableHeader, renderCell: ({ row }) => row?.kycTier?.name.replace('_', ' ') },
    { field: 'dateCreated', headerName: "Date", width: 150, headerClassName: styles.tableHeader, renderCell: ({ row }) => moment(row?.dateCreated).format('DD-MM-YYYY') },
    { field: 'status', headerName: "Status", width: 150, headerClassName: styles.tableHeader, renderCell: ({ row }) => row?.status.replace('_', ' ') },
    {
      field: " ",
      headerName: "Action ",
      width: 80,
      align: "right",
      headerClassName: styles.tableHeader,
      // renderCell: ({ row }) => (
      //   <AntDropdown
      //     dropDownOptions={[
      //       row?.status !=="APPROVED" && "APPROVE",
      //       row?.status !=="REJECTED" &&"REJECT",
      //       row?.cardActive && "BLOCK",
      //       !row?.cardActive && row?.status ==="APPROVED" && "UNBLOCK",
      //       row?.status !=="REJECTED" && row?.status !=="APPROVED" && "CANCEL",            
      //     ]}
      //     handleDropdownAction={(item) => handleDropdownAction(item, row)}
      //     userId={row}
      //     isArrow
      //   />
      // ),
      renderCell: ({ row }) => (
        <AntDropdown
          dropDownOptions={[
            "APPROVE",
            "REJECT",
            "BLOCK",
            "UNBLOCK",
            "DEACTIVATE",
            "ACTIVATE",
            "RESET PIN",
            "CANCEL",
            "EXPORT",
          ].filter(Boolean)}
          handleDropdownAction={(item) => handleDropdownAction(item, row)}
          userId={row}
          isArrow
        />
      ),
    },
  ];

  const handleChangePage = async (newPage) => {
    setPagination({ ...pagination, current: newPage });
  };
  const handleChangeRowsPerPage = async (e) => {
    setPagination({ ...pagination, current: 0, pageSize: e });
  };

  const getCards = async (e, page, size) => {
    if (e) e.preventDefault();
    showLoader();
    const pages = page === 0 ? 0 : (page || pagination.current);
    const limit = size || pagination.pageSize;

    let url = `${customBaseUrl.cardUrl}/cms/card-request/request/all?items=${limit}&page=${pages}&status=${statusFilter}`;
    if (field && value) {
      url += `&${field}=${value}`;
    }

    let request = await httpGet(url, null, true, false, null, true);
    if (request?.status) {
      hideLoader();
      setUsersData(request?.data?.cardList);
      setMetaData(request?.data?.totalElements);
    } else {
      hideLoader();
    }
  };

  const getExportData = async (done) => {
    showLoader();
    let url = `${customBaseUrl.cardUrl}/cms/card-request/request/all?items=${metaData}&page=0&status=${statusFilter}`;
    if (field && value) {
      url += `&${field}=${value}`;
    }

    const request = await httpGet(url, null, true, false, null, true);
    if (request?.status) {
      hideLoader();
      setExportData(request?.data?.cardList);
      done();
    } else {
      hideLoader();
      Swal.fire('Error', 'Could not fetch data for export.', 'error');
    }
  }

  useEffect(() => {
    getCards();
  }, [pagination.pageSize, pagination.current, statusFilter]);

  const category = ['customerId', 'status', 'name', 'email', 'phoneNumber'];
  const sCategory = ['INITIATED', 'UNDER_REVIEW', 'PENDING', 'APPROVED', 'REJECTED'];

  return (
    <Layout>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Card Requests" key="1">
          <Container>
            <Space style={{ marginBottom: 16, width: '100%' }}>
              <Select
                value={statusFilter}
                onChange={(value) => setStatusFilter(value)}
                style={{ width: 150 }}
              >
                <Option value="PENDING">Pending</Option>
                <Option value="APPROVED">Approved</Option>
                <Option value="CANCELLED">Cancelled</Option>
                <Option value="FAILED">Failed</Option>
                <Option value="REJECTED">Rejected</Option>
              </Select>
              {/* <Select
                    style={{ width: 150 }}
                    placeholder="Search by..."
                    onChange={(value) => setField(value)}
                    allowClear
                >
                    {category.map((cat) => (
                        <Option key={cat} value={cat}>{cat.replace('_',' ').toUpperCase()}</Option>
                    ))}
                </Select>
                {field === 'status' ? (
                    <Select
                        style={{ width: 200 }}
                        placeholder="Select status"
                        onChange={(value) => setValue(value)}
                        allowClear
                    >
                        {sCategory.map((sCat) => (
                            <Option key={sCat} value={sCat}>{sCat.replace('_',' ')}</Option>
                        ))}
                    </Select>
                ) : (
                    <Input
                        placeholder="Enter value"
                        style={{ width: 200 }}
                        onChange={(e) => setValue(e.target.value)}
                        allowClear
                    />
                )}
                <Button type="primary" onClick={() => getCards()}>Search</Button> */}
              <Button>
                <CSVLink
                  data={exportData}
                  filename={`cards.csv`}
                  asyncOnClick={true}
                  onClick={(event, done) => {
                    getExportData(done);
                  }}
                >
                  Export
                </CSVLink>
              </Button>
              <div style={{ flexGrow: 1 }} />
              <AntDropdown
                dropDownOptions={["Single Request"]}
                handleDropdownAction={(item) => handleSettingsDropdown(item)}
              >
                <Button>
                  Card Request
                </Button>
              </AntDropdown>
            </Space>

            <div style={{ height: 800, width: "100%" }}>
              {usersData?.length > 0 && <DataGrid
                className={styles.table}
                density="comfortable"
                rows={usersData}
                columns={columns}
                page={pagination.current}
                pageSize={pagination.pageSize}
                onPageSizeChange={(newPageSize) => handleChangeRowsPerPage(newPageSize)}
                paginationMode="server"
                onPageChange={(newPage) => handleChangePage(newPage)}
                rowsPerPageOptions={[5, 10, 20, 50, 100]}
                pagination
                components={{ Toolbar: GridToolbar }}
                rowCount={metaData}
              />}
            </div>

            {showViewDocModal && (
              <ViewDocModal
                showModal={showViewDocModal}
                hideModal={() => setShowViewDocModal(false)}
                data={viewData}
              />
            )}
            {showCreateBranch && (
              <CreateBranch
                showModal={showCreateBranch}
                hideModal={() => setShowCreateBranch(false)}
              />
            )}
            {showSingleCardRequestModal && (
              <SingleCardRequest
                showModal={showSingleCardRequestModal}
                hideModal={() => setShowSingleCardRequestModal(false)}
                getCards={getCards}
              />
            )}
          </Container>
        </TabPane>
        <TabPane tab="Product Type" key="3">
          <CardProducts />
        </TabPane>
        <TabPane tab="Card Type" key="4">
          <CardType />
        </TabPane>
        <TabPane tab="Delivery Fees" key="5">
          <DeliveryFees />
        </TabPane>
      </Tabs>
    </Layout>
  );
};
export default CardsMainPage;
